<template>
  <div class="page-wrapper" :class="{'tnc-open': view === 'tnc'}" style="font-family: Pretendard;">
    <div class="tnc-topbar" v-if="merchant && view === 'tnc'">
      <button type="button" class="tnc-back-btn" @click="closeTnc(false)">‹ Back</button>
    </div>
    <div class="background-page" v-if="merchant">
      <div class="container purchase-container">
        <div v-if="view === 'shop' || view === 'basket'" class="shop-body">
          <div class="virtual-card pass-card">
            <div class="virtual-card-top">
              <div class="virtual-card-merchant-block">
                <div class="virtual-card-merchant">{{merchant.title}}</div>
                <div class="virtual-card-address" v-if="merchantAddress">{{merchantAddress}}</div>
              </div>
              <div class="virtual-card-badge">Pass</div>
            </div>
          </div>

          <div class="section-title">Select Pass</div>
          <div v-if="plans.length === 0" class="shop-empty">
            No passes are available for purchase.
          </div>
          <div v-for="plan in plans" :key="'plan-' + plan.id"
               class="plan-card"
               :class="{'selected': selectedPlan && selectedPlan.id === plan.id}"
               @click="selectPlan(plan)">
            <div class="plan-head">
              <div class="plan-title">{{plan.title}}</div>
              <div class="plan-price">£{{planPrice(plan)}}</div>
            </div>
            <div class="plan-feature">
              <span class="plan-feature-icon icon-blue"><i class="far fa-calendar-alt"></i></span>
              <div class="plan-feature-text">
                <div class="plan-feature-title">{{planUsageTitle(plan)}}</div>
                <div class="plan-feature-sub">Flexible check-ins</div>
              </div>
              <span class="plan-feature-badge badge-blue">{{planUses(plan)}} {{planPeriodDays(plan) === 7 ? 'uses/wk' : 'uses'}}</span>
            </div>
            <div class="plan-feature">
              <span class="plan-feature-icon icon-green"><i class="fas fa-utensils"></i></span>
              <div class="plan-feature-text">
                <div class="plan-feature-title">{{planCombo(plan)}} included</div>
                <div class="plan-feature-sub">Complimentary with every visit</div>
              </div>
              <span class="plan-feature-badge badge-green">per use</span>
            </div>
            <div class="plan-feature">
              <span class="plan-feature-icon icon-purple"><i class="far fa-clock"></i></span>
              <div class="plan-feature-text">
                <div class="plan-feature-title">{{planValidityTitle(plan)}}</div>
                <div class="plan-feature-sub">Active from start date</div>
              </div>
              <span class="plan-feature-badge badge-purple">{{planValidityBadge(plan)}}</span>
            </div>
            <div class="plan-select-row">
              <span class="plan-select-check" :class="{'checked': selectedPlan && selectedPlan.id === plan.id}">
                <i class="fas fa-check"></i>
              </span>
              <span class="plan-select-label">{{selectedPlan && selectedPlan.id === plan.id ? 'Selected' : 'Select this pass'}}</span>
            </div>
          </div>

          <div class="sticky-cta" v-if="selectedPlan">
            <div v-if="errorMessage" class="shop-error">{{errorMessage}}</div>
            <button class="add-basket-btn" @click="goBasket">
              <img src="/static/img/basket_container.png" alt=""/>
              Add to basket
            </button>
          </div>
        </div>

        <transition name="sheet">
        <div v-if="view === 'basket' && selectedPlan" class="basket-overlay" @click.self="view = 'shop'">
        <div class="basket-sheet basket-body">
          <div class="basket-summary-title">Basket Summary</div>
          <div class="virtual-card basket-card">
            <div class="virtual-card-top">
              <div class="virtual-card-merchant-block">
                <div class="virtual-card-merchant">{{merchant.title}}</div>
                <div class="virtual-card-address" v-if="merchantAddress">{{merchantAddress}}</div>
              </div>
              <div class="virtual-card-badge">Pass</div>
            </div>
            <div class="virtual-card-bottom">
              <div class="virtual-card-label">{{selectedPlan.title}}</div>
              <div class="virtual-card-amount">£{{(selectedPlan.salePrice / 100).toFixed(2)}}</div>
              <div class="virtual-card-plan-desc">{{planSummary(selectedPlan)}}</div>
            </div>
          </div>
          <div class="form-block">
            Start date <span class="mandatory-text">*</span>
            <div class="date-chips">
              <div class="date-chip" :class="{'selected': startChoice === 'today'}" @click="setStartToday">Today</div>
              <div class="date-chip" :class="{'selected': startChoice === 'tomorrow'}" @click="setStartTomorrow">Tomorrow</div>
            </div>
            <div class="date-field" @click="openStartDatePicker">
              <span class="date-field-icon"><i class="far fa-calendar-alt"></i></span>
              <span class="date-field-text">{{startDateDisplay}}</span>
              <i class="fas fa-chevron-down date-field-chevron"></i>
              <input ref="startDateInput" type="date" class="date-native" :min="minStartDate" v-model="startDate"/>
            </div>
          </div>
          <div class="form-block">
            End date : <span class="date-field-text">{{endDateDisplay}}</span>
<!--            <div class="date-field date-field-readonly">-->
<!--              <span class="date-field-icon"><i class="far fa-calendar-alt"></i></span>-->
<!--              <span class="date-field-text">{{endDateDisplay}}</span>-->
<!--            </div>-->
          </div>
          <div class="form-block">
            Email <span class="mandatory-text">*</span>
            <input type="email" class="form-control" v-model="email" placeholder="email@example.com"/>
          </div>
          <div class="form-block">
            Name <span class="optional-text">(optional)</span>
            <input type="text" class="form-control" v-model="name" placeholder="Name"/>
          </div>
          <div class="form-block">
            Phone number <span class="optional-text">(optional)</span>
            <input type="tel" class="form-control" v-model="phone" placeholder="Phone"/>
          </div>
          <div class="form-block tnc-block">
            <span class="tnc-check" @click="acceptedTnc = !acceptedTnc">
              <i v-if="acceptedTnc" class="fas fa-check-square" style="color:#2F77E4;"></i>
              <i v-else class="far fa-square"></i>
            </span>
            <span>
              I agree to the
              <a href="#" class="tnc-link" @click.prevent="openTnc(false)">Terms and Conditions</a>
              of {{merchant.title}}. {{merchant.title}} is the seller of this Pass.
            </span>
          </div>
          <div class="basket-actions">
            <button class="positive-button checkout-btn" @click="checkout" :disabled="paying">Pay with card</button>
            <button class="back-btn" @click="view = 'shop'">Back</button>
          </div>
          <div v-if="errorMessage" class="basket-error">{{errorMessage}}</div>
        </div>
        </div>
        </transition>

        <div v-if="view === 'tnc'">
          <PassTnC :merchant="merchant" :plan="selectedPlan"/>
          <div v-if="!tncReadOnly" style="padding: 10px 15px 30px 15px;">
            <button class="positive-button checkout-btn" @click="closeTnc(true)">I agree</button>
          </div>
        </div>

        <div class="page-footer" v-if="view !== 'tnc'">
          <button type="button" class="tnc-footer-btn" @click="openTnc(true)">Terms & Conditions</button>
          <div class="footer-merchant">
            <strong>{{merchant.title}}</strong>
            <div v-if="merchantAddress">{{merchantAddress}}</div>
          </div>
          <div class="powered-by">
            Powered by <strong>Borium Studio Limited</strong>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="errorMessage" style="padding: 40px; text-align:center;">{{errorMessage}}</div>
    <div v-else class="page-gif-loader">
      <UtensilLoader/>
    </div>
  </div>
</template>

<script>
import {getMerchant, getMerchantPermalink, getMerchantUrl, getPassMerchant, purchasePass} from "../api/borium";
import PassTnC from "./PassTnC.vue";
import UtensilLoader from "./UtensilLoader.vue";

export default {
  name: 'Pass',
  components: { PassTnC, UtensilLoader },
  data() {
    return {
      merchant: false,
      plans: [],
      selectedPlan: null,
      view: 'shop',
      email: '',
      name: '',
      phone: '',
      startChoice: 'today',
      startDate: '',
      acceptedTnc: false,
      tncFrom: 'shop',
      tncReadOnly: false,
      errorMessage: '',
      stripe: null,
      paying: false,
    }
  },
  computed: {
    merchantAddress: function() {
      if (!this.merchant) {
        return '';
      }
      let parts = [];
      if (this.merchant.address) {
        parts.push(String(this.merchant.address).replace(/\n/g, ', '));
      }
      if (this.merchant.city) parts.push(this.merchant.city);
      if (this.merchant.postCode) parts.push(this.merchant.postCode);
      return parts.join(', ');
    },
    subscriptionId: function() {
      if (!this.merchant) {
        return 0;
      }
      if (this.merchant.subscriptionId) {
        return this.merchant.subscriptionId;
      }
      if (this.merchant.merchantId) {
        return this.merchant.merchantId;
      }
      return this.merchant.id;
    },
    minStartDate: function() {
      return this.londonYmd(0);
    },
    startDateDisplay: function() {
      if (!this.startDate) {
        return 'Select date';
      }
      let d = new Date(this.startDate + 'T00:00:00');
      return d.toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'});
    },
    endDateDisplay: function() {
      if (!this.startDate || !this.selectedPlan) {
        return '';
      }
      if (!(this.selectedPlan.validDays > 0)) {
        return 'No expiry';
      }
      let d = new Date(this.startDate + 'T00:00:00');
      d.setDate(d.getDate() + this.selectedPlan.validDays - 1);
      return d.toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'});
    }
  },
  watch: {
    view: function(newView, oldView) {
      if (newView !== 'tnc' && oldView !== 'tnc') {
        return;
      }
      this.$nextTick(function() {
        if (this.$el) {
          this.$el.scrollTop = 0;
        }
      });
    },
    startDate: function(value) {
      if (!value) {
        return;
      }
      if (value === this.londonYmd(0)) {
        this.startChoice = 'today';
      } else if (value === this.londonYmd(1)) {
        this.startChoice = 'tomorrow';
      } else {
        this.startChoice = 'custom';
      }
    }
  },
  mounted() {
    this.startDate = this.londonYmd(0);
    this.loadMerchant();
  },
  beforeDestroy() {
    if (this.loaderPreviewTimer) {
      clearTimeout(this.loaderPreviewTimer);
    }
  },
  methods: {
    londonYmd: function(daysFromToday) {
      let today = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(new Date());
      if (!daysFromToday) {
        return today;
      }
      let parts = today.split('-');
      let utc = Date.UTC(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10) + daysFromToday);
      return new Date(utc).toISOString().slice(0, 10);
    },
    startDateMillis: function() {
      if (!this.startDate) {
        return 0;
      }
      return Date.parse(this.startDate + 'T00:00:00+00:00');
    },
    setStartToday: function() {
      this.startDate = this.londonYmd(0);
      this.startChoice = 'today';
    },
    setStartTomorrow: function() {
      this.startDate = this.londonYmd(1);
      this.startChoice = 'tomorrow';
    },
    openStartDatePicker: function() {
      let input = this.$refs.startDateInput;
      if (!input) {
        return;
      }
      if (typeof input.showPicker === 'function') {
        try {
          input.showPicker();
          return;
        } catch (e) {
          // fall through to focus
        }
      }
      input.focus();
      input.click();
    },
    planUses: function(plan) {
      return (plan && plan.usesPerWeek) || 5;
    },
    planPeriodDays: function(plan) {
      if (plan && plan.usePeriodDays > 0) {
        return plan.usePeriodDays;
      }
      if (plan && plan.validDays > 0) {
        return plan.validDays;
      }
      return 7;
    },
    planUsageTitle: function(plan) {
      let days = this.planPeriodDays(plan);
      if (days === 7) {
        return this.planUses(plan) + ' usage per week';
      }
      return this.planUses(plan) + ' usage for ' + days + ' days';
    },
    planCombo: function(plan) {
      let food = (plan && plan.foodPerUse) || 1;
      let drink = (plan && plan.drinkPerUse) || 1;
      return food + ' Food + ' + drink + ' Drink';
    },
    planValidityTitle: function(plan) {
      if (plan && plan.validDays > 0) {
        return plan.validDays + ' Days Validity';
      }
      return 'No Expiry';
    },
    planValidityBadge: function(plan) {
      if (plan && plan.validDays > 0) {
        return plan.validDays + ' Days';
      }
      return 'No expiry';
    },
    planSummary: function(plan) {
      if (!plan) {
        return '';
      }
      let uses = plan.usesPerWeek || 5;
      let food = plan.foodPerUse || 1;
      let drink = plan.drinkPerUse || 1;
      let text = uses + ' usages · ' + food + ' food + ' + drink + ' drink each use';
      if (plan.validDays > 0) {
        text += ' · for ' + plan.validDays + ' days';
      } else {
        text += ' · no expiry';
      }
      return text;
    },
    planPrice: function(plan) {
      if (!plan) {
        return '0';
      }
      let n = plan.salePrice / 100;
      if (Math.round(n) === n) {
        return String(n);
      }
      return n.toFixed(2);
    },
    applyPlans: function(list) {
      this.plans = list || [];
      if (this.plans.length === 0) {
        this.selectedPlan = null;
        return;
      }
      if (this.selectedPlan) {
        let keepId = this.selectedPlan.id;
        let found = null;
        for (let i = 0; i < this.plans.length; i++) {
          if (this.plans[i].id === keepId) {
            found = this.plans[i];
            break;
          }
        }
        this.selectedPlan = found;
        return;
      }
      this.selectedPlan = null;
    },
    selectPlan: function(plan) {
      if (this.selectedPlan && this.selectedPlan.id === plan.id) {
        this.selectedPlan = null;
      } else {
        this.selectedPlan = plan;
      }
      this.errorMessage = '';
    },
    loadMerchant: function() {
      let self = this;
      if (this.$route.params.permalink) {
        getMerchantPermalink(this.$route.params.permalink)
          .then(function(data) {
            self.applyMerchant(data);
          })
          .catch(function() {
            self.loadFromSpring();
          });
        return;
      }
      if (this.$route.params.id) {
        getMerchant(this.$route.params.id)
          .then(function(data) {
            self.applyMerchant(data);
          })
          .catch(function() {
            self.loadFromSpring();
          });
        return;
      }
      let host = window.location.host;
      getMerchantUrl('https://' + host)
        .then(function(data) {
          if (data.success) {
            self.applyMerchant(data);
          } else {
            self.loadFromSpring();
          }
        })
        .catch(function() {
          self.loadFromSpring();
        });
    },
    loadFromSpring: function() {
      let self = this;
      getPassMerchant(this.$route.params.id, this.$route.params.permalink, window.location.host)
        .then(function(data) {
          if (data.success && data.item) {
            self.merchant = data.item;
            self.applyPlans(data.list || []);
          } else {
            self.errorMessage = data.message || 'Cannot find restaurant';
          }
        })
        .catch(function() {
          self.errorMessage = 'Cannot find restaurant';
        });
    },
    applyMerchant: function(data) {
      if (data.success === true && data.item) {
        this.merchant = data.item;
        this.loadPlans();
      } else {
        this.loadFromSpring();
      }
    },
    keepMerchantDetails: function(fromPhp, fromSpring) {
      if (!fromSpring) {
        return fromPhp;
      }
      if (!fromPhp) {
        return fromSpring;
      }
      let merged = Object.assign({}, fromSpring);
      if (!merged.address && fromPhp.address) {
        merged.address = fromPhp.address;
      }
      if (!merged.city && fromPhp.city) {
        merged.city = fromPhp.city;
      }
      if (!merged.postCode && fromPhp.postCode) {
        merged.postCode = fromPhp.postCode;
      }
      if (!merged.phoneNumber && fromPhp.phoneNumber) {
        merged.phoneNumber = fromPhp.phoneNumber;
      }
      if (!merged.registeredTitle && fromPhp.registeredTitle) {
        merged.registeredTitle = fromPhp.registeredTitle;
      }
      if (!merged.logo && fromPhp.logo) {
        merged.logo = fromPhp.logo;
      }
      if (!merged.logo && fromPhp.imageUrl) {
        merged.logo = String(fromPhp.imageUrl).split(',')[0];
      }
      return merged;
    },
    loadPlans: function() {
      let self = this;
      getPassMerchant(this.subscriptionId, this.$route.params.permalink, window.location.host)
        .then(function(data) {
          if (data.success) {
            if (data.item) {
              self.merchant = self.keepMerchantDetails(self.merchant, data.item);
            }
            self.applyPlans(data.list || []);
          }
        });
    },
    goBasket: function() {
      if (!this.selectedPlan) {
        this.errorMessage = 'Choose a pass';
        return;
      }
      this.errorMessage = '';
      this.view = 'basket';
    },
    openTnc: function(readOnly) {
      if (this.view !== 'tnc') {
        this.tncFrom = this.view;
        this.tncReadOnly = !!readOnly;
      }
      this.view = 'tnc';
      this.$nextTick(function() {
        if (this.$el) {
          this.$el.scrollTop = 0;
        }
      });
    },
    closeTnc: function(agree) {
      if (agree) {
        this.acceptedTnc = true;
      }
      this.view = this.tncFrom || 'shop';
    },
    checkout: function() {
      if (!this.email || this.email.indexOf('@') < 0) {
        this.errorMessage = 'Email is required';
        return;
      }
      if (!this.startDate) {
        this.errorMessage = 'Start date is required';
        return;
      }
      if (this.startDate < this.minStartDate) {
        this.errorMessage = 'Start date cannot be earlier than today';
        return;
      }
      if (!this.acceptedTnc) {
        this.errorMessage = 'Please agree to the Terms and Conditions';
        return;
      }
      if (!this.selectedPlan) {
        this.errorMessage = 'Choose a pass';
        return;
      }
      this.errorMessage = '';
      this.paying = true;
      let self = this;
      let payload = {
        subscriptionId: this.subscriptionId,
        merchantId: this.merchant.id || 0,
        permalink: this.$route.params.permalink || '',
        planId: this.selectedPlan.id,
        email: this.email.trim().toLowerCase(),
        name: this.name,
        phone: this.phone,
        sendAsGift: false,
        recipientEmail: '',
        giftMessage: '',
        validFrom: this.startDateMillis(),
        redirectUrl: window.location.origin,
      };
      this.$nextTick(function() {
        purchasePass(payload)
          .then(function(data) {
            self.paying = false;
            if (!data.success) {
              self.errorMessage = data.message || 'Could not start payment';
              return;
            }
            let item = data.item;
            if (item.teyaSessionUrl) {
              window.location.href = item.teyaSessionUrl;
              return;
            }
            if (item.stripePublicKey) {
              if (item.stripeClientId) {
                self.stripe = Stripe(item.stripePublicKey, {stripeAccount: item.stripeClientId});
              } else {
                self.stripe = Stripe(item.stripePublicKey);
              }
              return self.stripe.redirectToCheckout({sessionId: item.pgToken});
            }
            self.errorMessage = 'Could not start payment';
          })
          .catch(function() {
            self.paying = false;
            self.errorMessage = 'Could not start payment. Please try again.';
          });
      });
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #f3f4f6;
  box-sizing: border-box;
  padding-top: 0;
}
.page-wrapper.tnc-open {
  padding-top: 0;
}
.tnc-topbar {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 50;
  background: white;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 8px;
  box-sizing: border-box;
}
.tnc-back-btn {
  background: none;
  border: none;
  color: #102E5A;
  font-weight: 700;
  font-size: 16px;
  padding: 10px 12px;
  cursor: pointer;
}
.background-page {
  background: #f3f4f6;
  min-height: 100%;
}
.basket-summary-title {
  padding: 10px 0;
  font-size: 20px;
  font-weight: 700;
}
.shop-body,
.basket-body {
  padding: 20px 0 8px 0;
  text-align: left;
}
.basket-sheet.basket-body {
  padding: 20px 16px 28px 16px;
}
@media (min-width: 600px) {
  .shop-body,
  .basket-body {
    padding-left: 18px;
    padding-right: 18px;
  }
}
.virtual-card {
  background: linear-gradient(145deg, #0a2a52 0%, #031635 55%, #021024 100%);
  border-radius: 18px;
  min-height: 190px;
  padding: 22px 22px 20px 22px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 8px 24px rgba(3, 22, 53, 0.28);
}
.virtual-card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.virtual-card-merchant-block {
  min-width: 0;
  padding-right: 12px;
}
.virtual-card-merchant {
  font-size: 22px;
  font-weight: 500;
  line-height: 1.2;
}
.virtual-card-address {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  opacity: 0.8;
}
.virtual-card.pass-card {
  min-height: 0;
  justify-content: flex-start;
}
.basket-card {
  margin-bottom: 20px;
}
.virtual-card-bottom {
  margin-top: 20px;
}
.virtual-card-label {
  font-size: 12px;
  letter-spacing: 0.08em;
  opacity: 0.9;
  font-weight: 600;
  text-transform: uppercase;
}
.virtual-card-amount {
  font-size: 36px;
  font-weight: 600;
  line-height: 1.15;
  margin-top: 2px;
}
.virtual-card-plan-desc {
  margin-top: 6px;
  font-size: 14px;
  line-height: 1.4;
  opacity: 0.8;
}
.virtual-card-badge {
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1;
  opacity: 0.95;
}
.section-title {
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin: 28px 0 14px 0;
}
.shop-empty {
  padding: 10px 0 18px 0;
  color: #888;
}
.plan-card {
  margin: 0 0 14px 0;
  padding: 20px;
  border: 1.5px solid #d8dce3;
  border-radius: 22px;
  cursor: pointer;
  text-align: left;
  background: #fff;
  color: #031635;
}
.plan-card.selected {
  border-color: #031635;
  border-width: 2px;
  padding: 19.5px;
  box-shadow: 0 6px 18px rgba(3, 22, 53, 0.10);
}
.plan-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 14px;
}
.plan-title {
  font-weight: 700;
  font-size: 19px;
  min-width: 0;
}
.plan-price {
  font-weight: 800;
  font-size: 26px;
  flex-shrink: 0;
}
.plan-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f6f7f9;
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 10px;
}
.plan-feature-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}
.icon-blue { color: #2F77E4; }
.icon-green { color: #1d9e63; }
.icon-purple { color: #6b5ce7; }
.plan-feature-text {
  flex: 1;
  min-width: 0;
}
.plan-feature-title {
  font-weight: 600;
  font-size: 15px;
}
.plan-feature-sub {
  font-size: 12.5px;
  color: #7a8394;
  margin-top: 1px;
}
.plan-feature-badge {
  flex-shrink: 0;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 10px;
  padding: 5px 10px;
}
.badge-blue { background: #e7effd; color: #2F77E4; }
.badge-green { background: #e2f6ec; color: #1d9e63; }
.badge-purple { background: #ecebfb; color: #6b5ce7; }
.plan-select-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px solid #eef0f3;
}
.plan-select-check {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #c4cad4;
  background: #fff;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}
.plan-select-check.checked {
  background: #031635;
  border-color: #031635;
  color: #fff;
}
.plan-select-label {
  font-weight: 700;
  font-size: 15px;
}
.sticky-cta {
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 20px;
  padding: 10px 0 14px 0;
  background: linear-gradient(180deg, rgba(243,244,246,0) 0%, #f3f4f6 40%);
}
.add-basket-btn {
  width: 100%;
  border: none;
  background: #031635;
  color: #fff;
  font-weight: 500;
  font-size: 17px;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}
.add-basket-btn img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  mix-blend-mode: screen;
}
.shop-error {
  margin-bottom: 10px;
  color: #c00;
  text-align: center;
}
.basket-actions {
  padding: 20px 0;
}
.basket-error {
  padding: 0 0 20px 0;
  color: #c00;
}
.form-block {
  text-align: left;
  padding: 8px 0;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.date-field {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d8dce3;
  border-radius: 14px;
  padding: 10px 40px 10px 14px;
  cursor: pointer;
}
.date-field-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #e7effd;
  color: #2F77E4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}
.date-field-text {
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  color: #031635;
  line-height: 34px;
}
.date-field-chevron {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #8a93a3;
  font-size: 13px;
}
.date-field-readonly {
  cursor: default;
  padding: 10px 14px;
}
.date-native {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}
.tnc-block {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  line-height: 1.4;
}
.tnc-check {
  font-size: 22px;
  margin-right: 10px;
  cursor: pointer;
  line-height: 1;
}
.tnc-link {
  color: #2F77E4;
  text-decoration: underline;
}
.date-chips {
  display: flex;
  margin: 8px 0;
  max-width: 100%;
  box-sizing: border-box;
}
.date-chip {
  flex: 1;
  min-width: 0;
  margin-right: 8px;
  padding: 12px 0;
  text-align: center;
  border: 1px solid #d8dce3;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  background: #fff;
  color: #031635;
}
.date-chip:last-child {
  margin-right: 0;
}
.date-chip.selected {
  background: #031635;
  color: white;
  border-color: #031635;
}
.mandatory-text {
  color: #E84725;
}
.optional-text {
  color: #888;
  font-size: 13px;
}
.checkout-btn {
  padding: 16px 50px;
  border: none;
  width: 100%;
  background: #031635;
  color: white;
  font-weight: bold;
  border-radius: 12px;
}
.checkout-btn:disabled {
  opacity: 0.5;
}
.back-btn {
  margin-top: 10px;
  width: 100%;
  padding: 12px;
  border: none;
  background: #eee;
  border-radius: 10px;
}
.basket-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(3, 22, 53, 0.45);
  z-index: 300;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.basket-sheet {
  background: #f3f4f6;
  width: 100%;
  max-width: 600px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 16px 28px 16px;
  box-sizing: border-box;
}
.sheet-enter-active,
.sheet-leave-active {
  transition: opacity 0.3s ease;
}
.sheet-enter-active .basket-sheet,
.sheet-leave-active .basket-sheet {
  transition: transform 0.3s ease;
}
.sheet-enter,
.sheet-leave-to {
  opacity: 0;
}
.sheet-enter .basket-sheet,
.sheet-leave-to .basket-sheet {
  transform: translateY(100%);
}
.purchase-container.container,
.purchase-container {
  position: relative;
  background: #f3f4f6;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  overflow-x: clip;
  box-sizing: border-box;
}
.page-footer {
  margin-top: auto;
  padding: 28px 15px 36px 15px;
  border-top: 1px solid #eee;
  text-align: center;
}
.tnc-footer-btn {
  display: inline-block;
  background: #f3f4f7;
  border: none;
  border-radius: 10px;
  color: #102E5A;
  font-weight: 700;
  font-size: 14px;
  padding: 12px 22px;
  cursor: pointer;
}
.footer-merchant {
  margin-top: 16px;
  font-size: 13px;
  color: #333;
  line-height: 1.45;
}
.powered-by {
  margin-top: 12px;
  font-size: 12px;
  color: #666;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pass.vue